const mutations = {
  setOptionsTarget(state, target) {
    state.options.target = target;
  },
  setCategory(state, category) {
    state.options[category.name.toLowerCase()] = category.active;
  },
  setPurity(state, purity) {
    state.options[purity.name.toLowerCase()] = purity.active;
  },
};

export default mutations;
